import { useCallback } from 'react';

interface MoveSlideByButtonProps {
    currentSlideIndex: number;
    setCurrentSlideIndex: (slideIndex: number) => void;
    itemsToScroll?: number;
}

export const useMoveBackward = function ({
    currentSlideIndex,
    setCurrentSlideIndex,
    itemsToScroll = 1,
}: MoveSlideByButtonProps) {
    return useCallback(
        (count: number = itemsToScroll) => {
            setCurrentSlideIndex(Math.max(currentSlideIndex - count, 0));
        },
        [currentSlideIndex, itemsToScroll, setCurrentSlideIndex],
    );
};
